import React, { useCallback } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { ConfirmUserRegistration } from "../services/AccountService";
import { useAxiosInstance } from "../services/Interceptor";

export default function ConfirmRegistration() {
  const [searchParams] = useSearchParams();
  const [confirmationText, setConfirmationText] = useState("");
  const [showLink, setShowLink] = useState(false);
  const apiInstance = useAxiosInstance();

  const doConfirmation = useCallback(() => {
    const registrationCode = searchParams.get("registrationCode") ?? "";
    const email = searchParams.get("email") ?? "";

    ConfirmUserRegistration(apiInstance, registrationCode, email).then(
      (result) => {
        if (result === true) {
          setShowLink(true);
          setConfirmationText("Your email has been confirmed!");
        } else if (typeof result === "string") {
          setShowLink(false);
          setConfirmationText(result);
        } else {
          setShowLink(false);
          setConfirmationText(
            "There was a problem confirming your email. Please try again later.",
          );
        }
      },
    );
  }, [searchParams, apiInstance]);

  useEffect(() => {
    doConfirmation();
  }, [doConfirmation]);

  return (
    <section className="flex flex-col md:flex-row h-screen items-center justify-center bg-gray-100">
      <div className="hidden md:flex w-full md:w-1/2 h-screen items-center justify-center">
        <img
          src="/default-profile-img.png"
          alt="Confirmation"
          className="w-4/5 max-w-md object-cover rounded-xl shadow-lg"
        />
      </div>

      <div className="bg-white w-full md:w-1/2 xl:w-1/3 h-auto py-12 px-8 md:px-12 shadow-lg rounded-xl text-center">
        <h1 className="text-2xl font-bold text-gray-700">{confirmationText}</h1>

        {showLink && (
          <Link
            to="/"
            className="mt-6 inline-block px-6 py-2 text-lg font-semibold text-white bg-blue-600 rounded-md hover:bg-blue-700 transition-all duration-300 shadow-md"
          >
            Click here to sign in to Trackit
          </Link>
        )}
      </div>
    </section>
  );
}
